import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';
import { useLang } from '../hooks/useLang';
import './Auth.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await signIn(email, password);
    if (error) { setError(error.message); setLoading(false); }
    else navigate('/dashboard');
  }

  async function handleOAuth(provider) {
    await supabase.auth.signInWithOAuth({
      provider,
      options: { redirectTo: `${window.location.origin}/dashboard` },
    });
  }

  return (
    <div className="page auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="auth-logo">Transport<span>ily</span></Link>
          <h2>{t('auth.welcomeBack')}</h2>
          <p>{t('auth.signInSub')}</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <div style={{ display:'flex', flexDirection:'column', gap:'8px', marginBottom:'16px' }}>
          <button type="button" onClick={() => handleOAuth('google')}
            style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'10px', width:'100%', padding:'11px 16px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:'12px', color:'var(--sand)', fontSize:'14px', fontWeight:'600', cursor:'pointer', fontFamily:'inherit' }}
            onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.09)'}
            onMouseLeave={e => e.currentTarget.style.background='rgba(255,255,255,0.05)'}>
            <span style={{fontSize:'18px'}}>🔵</span> Continue with Google
          </button>
        </div>

        <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'16px' }}>
          <div style={{ flex:1, height:'1px', background:'rgba(255,255,255,0.08)' }} />
          <span style={{ color:'var(--olive)', fontSize:'12px', whiteSpace:'nowrap' }}>or sign in with email</span>
          <div style={{ flex:1, height:'1px', background:'rgba(255,255,255,0.08)' }} />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.emailLabel')}</label>
            <input type="email" placeholder={t('auth.emailPlaceholder')} value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>{t('auth.passwordLabel')}</label>
            <input type="password" placeholder={t('auth.passwordPlaceholder')} value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? '...' : t('auth.signInBtn')}
          </button>
        </form>

        <p className="auth-footer">
          {t('auth.noAccount')} <Link to="/register">{t('auth.createOneFree')}</Link>
        </p>
      </div>
    </div>
  );
}